<div class="page-title">
    <button class="btn link-btn btn-back">
        <i class="app-icon icon icon-chevron-left icon-xxl" (click)="backHandler()"></i>
    </button>
    {{'payment.detail.title' | translate}}
    <span HJSuppress class="payment-number fw-bold text-primary">{{payment?.number}}</span>
</div>

<div class="row row-details">
    <div class="col-lg-6 text-center text-lg-start">
        <div class="subtitle ms-lg-5">
            {{'payment.detail.client' | translate}}:
            <span HJSuppress class="subtitle-value">{{payment?.partnerUniqueIdentifier}}</span>
            <button class="btn copy-clipboard-btn ms-2" [cdkCopyToClipboard]="payment?.partnerUniqueIdentifier" (click)="showClipboardNotification()">
                <i class="app-icon icon icon-copy icon-md2"></i>
            </button>
        </div>
    </div>

    <div class="col-lg-6 text-center text-lg-end">
        <div class="subtitle">
            {{'payment.detail.date' | translate}}:
            <span HJSuppress class="subtitle-value">{{payment?.date | localizedDate}}</span>
        </div>
        <div class="subtitle text-secondary">
            {{'payment.detail.value' | translate}}:
            <span HJSuppress class="subtitle-value-lg text-primary">
                {{payment?.value | number : '1.'}} {{payment?.currencyCode}}
            </span>
        </div>
    </div>
</div>

<div class="d-flex flex-column justify-content-center" *ngIf="!hasData">
    <h3 class="text-center text-secondary my-4">{{'payment.detail.noInvoices' | translate}}</h3>
    <no-records-placeholder></no-records-placeholder>
</div>

<dynamic-table *ngIf="hasData" [props]="props">
    <table class="responsive-table">
        <thead>
            <tr class="table-header">
                <th id="InvoiceNumber" class="table-header-title">{{'payment.detail.invoiceNumber' | translate}}</th>
                <th id="Contracts" class="table-header-title">{{'payment.detail.contract' | translate}}</th>
                <th id="IssuedDate" class="table-header-title">{{'payment.detail.issuedDate' | translate}}</th>
                <th id="DueDate" class="table-header-title">{{'payment.detail.dueDate' | translate}}</th>
                <th id="InvoicedAmount" class="table-header-title">{{'payment.detail.invoicedAmount' | translate}}</th>
                <th id="PaidAmount" class="table-header-title">{{'payment.detail.paidAmount' | translate}}</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let invoice of payment?.invoices">
                <tr class="row-container ccc ccc-table-row">
                    <td HJSuppress [attr.data-label]="'payment.detail.invoiceNumber' | translate" class="column-content">
                        <div class="cell-data">
                            <div class="cell-label">{{'payment.detail.invoiceNumber' | translate}}</div>
                            <div class="cell-value text-primary">{{invoice?.invoiceNumber}}</div>
                        </div>
                    </td>
                    <td HJSuppress [attr.data-label]="'payment.detail.contract' | translate" class="column-content">
                        <div class="cell-data">
                            <div class="cell-label align-self-start">{{'payment.detail.contract' | translate}}</div>
                            <div class="cell-value">
                                <div *ngIf="invoice?.contracts.length > 0" class="d-flex flex-column align-items-end align-items-md-center">
                                    <div HJSuppress *ngFor="let contract of invoice?.contracts | slice: 0 : 2">
                                        {{contract.contractNumber}}
                                    </div>
                                    <button *ngIf="invoice?.contracts.length > 2" 
                                        type="button" class="btn view-more-btn"
                                        (click)="openDetailsListModalInvoiceContracts($event, invoice?.contracts)"
                                    >
                                        {{'common.viewMore' | translate}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </td>
                    <td HJSuppress [attr.data-label]="'payment.detail.issuedDate' | translate" class="column-content">
                        <div class="cell-data">
                            <div class="cell-label">{{'payment.detail.issuedDate' | translate}}</div>
                            <div class="cell-value">{{invoice?.issuedDate | localizedDate}}</div>
                        </div>
                    </td>
                    <td HJSuppress [attr.data-label]="'payment.detail.dueDate' | translate" class="column-content">
                        <div class="cell-data">
                            <div class="cell-label">{{'payment.detail.dueDate' | translate}}</div>
                            <div class="cell-value">{{invoice?.dueDate | localizedDate}}</div>
                        </div>
                    </td>
                    <td HJSuppress [attr.data-label]="'payment.detail.invoicedAmount' | translate" class="column-content">
                        <div class="cell-data">
                            <div class="cell-label">{{'payment.detail.invoicedAmount' | translate}}</div>
                            <div class="cell-value">{{invoice?.invoicedAmount | number : '1.'}} {{payment?.currencyCode}}</div>
                        </div>
                    </td>
                    <td HJSuppress [attr.data-label]="'payment.detail.paidAmount' | translate" class="column-content">
                        <div class="cell-data">
                            <div class="cell-label">{{'payment.detail.paidAmount' | translate}}</div>
                            <div class="cell-value text-primary">{{invoice?.paidAmount | number : '1.'}} {{payment?.currencyCode}}</div>
                        </div>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</dynamic-table>
